export default "<div id='ms_captcha_holder' align='center'></div>\n<div id='ms_captcha_scriptholder' style='display: inline'>\n</div>\n"